// extracted by mini-css-extract-plugin
export default {"menu-items-list":"styles_menu-items-list__cgRzB","dropdownList":"styles_dropdownList__DvOt0"};